import { FC } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';
import { CheckSvg } from './svgs';

export const IconCheck: FC<SvgIconProps> = (props) => {
  return <SvgIcon component={CheckSvg} viewBox="0 0 24 24" {...props} />;
};
